import React from "react";
import {
  Box,
  Container,
  Divider,
  IconButton,
  Link as MuiLink,
  Stack,
  Typography,
} from "@mui/material";
import NextLink from "next/link";
import generateConfig from "../../../util/config";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";

const config = generateConfig();
const contactEmail = config.contactEmail;

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        background: (theme) =>
          `linear-gradient(180deg, ${theme.palette.background.paper} 0%, ${theme.palette.grey[100]} 100%)`,
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
        mt: 8,
        py: 6,
      }}
    >
      <Container maxWidth="lg">
        <Stack
          spacing={4}
          direction={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", md: "center" }}
        >
          <Stack spacing={1}>
            <Typography variant="h3" component="span" sx={{ fontWeight: 700 }}>
              {config.logoName || "Krushna Raut"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Product-focused engineer crafting immersive web experiences with
              code, motion, and empathy.
            </Typography>
          </Stack>
          <Stack direction="row" spacing={3}>
            <IconButton
              component={NextLink}
              href="https://github.com/technicalshree"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
            >
              <GitHubIcon />
            </IconButton>
            <IconButton
              component={NextLink}
              href="https://www.linkedin.com/in/krushnaraut/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <LinkedInIcon />
            </IconButton>
            <IconButton
              component={NextLink}
              href={`mailto:${contactEmail}`}
              aria-label="Email"
            >
              <AlternateEmailIcon />
            </IconButton>
          </Stack>
        </Stack>
        <Divider sx={{ my: 4 }} />
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={2}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", md: "center" }}
          color="text.secondary"
        >
          <Typography variant="body2">
            {config.siteName || "Krushna Raut"} {new Date().getFullYear()} - All
            rights reserved
          </Typography>
          <Stack direction="row" spacing={3}>
            <MuiLink
              component={NextLink}
              href={`/contact`}
              underline="none"
              variant="body2"
            >
              Contact
            </MuiLink>
            <MuiLink
              component={NextLink}
              href="/signin"
              underline="none"
              variant="body2"
            >
              Sign in
            </MuiLink>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
